import { ComponentType } from "react";

import { SurveyResponse } from "@/redux/survey/types";

export interface GuidancePageProps {
  survey: SurveyResponse;
  open?: boolean;
  setOpen?: (value: boolean) => void;
}

export interface GuidancePageSection {
  key: string;
  href: string;
  titleKey: string;
  icon: ComponentType<{ width?: string; height?: string }>;
}

export interface GuidancePageCardItem {
  key: string;
  icon: ComponentType<{ size?: number }>;
  titleKey: string;
  descriptionKey: string;
}

export const CHECKLIST_LABEL_LINKS = {
  PREVIEW: "preview",
  TUTORIAL: "tutorial",
} as const;

export type ChecklistLabelLink =
  (typeof CHECKLIST_LABEL_LINKS)[keyof typeof CHECKLIST_LABEL_LINKS];

interface ChecklistItem {
  id: string;
  labelKey: string;
  descriptionKeys?: string[];
  labelLink?: ChecklistLabelLink;
}

export interface PreparationChecklistAccordionItem {
  key: string;
  icon: ComponentType<{ size?: number }>;
  titleKey: string;
  items: ChecklistItem[];
}

export interface CalendarCardProps {
  date: string;
  title: string;
  description: string;
  tag?: string;
  linkUrl?: string;
  linkLabel?: string;
}

export interface SampleSurveyCardProps {
  title: string;
  reportPath: string;
  reportViewPath?: string;
  surveyType: string;
}

export interface TestimonialCardProps {
  stepNumber: number;
  title: string;
  description: string;
  attribution: string;
}

export type SipPreviewMap = Record<string, { link: string }>;
